var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"nav-tab"},_vm._l((_vm.linkArr),function(item,index){return _c('router-link',{key:index,attrs:{"to":item.to,"tag":"li","replace":""}},[_vm._v(" "+_vm._s(item.text)+" ")])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }